<div class="row">
    <div class="col-3"></div>
    <div class="col-9"></div>
</div>
<div class=" frame">
    <div class="sidebar sticky-top">
        <div class="widget-container">
          <div class="float-right">
            <button class="btn" (click)="clearAll.emit()"><fa-icon [icon]="faRedoAlt"></fa-icon></button>
          </div>
            <div class="widget-name is-head">
                Refine Results
                <!-- <div *ngIf="updatingFilters"
                    class="spinner">
                    <div class="spinner-bar"></div>
                </div> -->
            </div>
            <filter-checkbox-list
                searchType="COMPANY"
                title="Company Name"
                [items]="filters.companyName.items"
                [collapsed]="filters.companyName.collapsed"
                (toggled)="filterToggled.emit('companyName')"
                (changed)="filter({ companyName: $event.items, filterName: 'companyName' })">
            </filter-checkbox-list>
          <filter-checkbox-list
            title="Industry"
            searchType="COMPANY"
            [items]="filters.industry.items"
            [collapsed]="filters.industry.collapsed"
            (toggled)="filterToggled.emit('industry')"
            (changed)="filter({ industry: $event.items, filterName: 'industry' })">
          </filter-checkbox-list>
            <filter-checkbox-list
                title="Employees"
                searchType="COMPANY"
                [items]="filters.employeeRange.items"
                [collapsed]="filters.employeeRange.collapsed"
                (toggled)="filterToggled.emit('employeeRange')"
                (changed)="filter({ employeeRange: $event.items, filterName: 'employeeRange' })">
            </filter-checkbox-list>
            <filter-checkbox-list
                title="Revenue"
                searchType="COMPANY"
                [items]="filters.revenueRange.items"
                [collapsed]="filters.revenueRange.collapsed"
                (toggled)="filterToggled.emit('revenueRange')"
                (changed)="filter({ revenueRange: $event.items, filterName: 'revenueRange' })">
            </filter-checkbox-list>
            <filter-checkbox-list
                title="Ownership"
                searchType="COMPANY"
                [items]="filters.ownership.items"
                [collapsed]="filters.ownership.collapsed"
                (toggled)="filterToggled.emit('ownership')"
                (changed)="filter({ ownership: $event.items, filterName: 'ownership' })">
            </filter-checkbox-list>
            <filter-checkbox-list
              title="Location"
              searchType="COMPANY"
                [items]="filters.location.items"
                [collapsed]="filters.location.collapsed"
                (toggled)="filterToggled.emit('location')"
                (changed)="filter({ location: $event.items, filterName: 'location' })">
            </filter-checkbox-list>
          <filter-checkbox-list
            title="Country"
            searchType="COMPANY"
            [items]="filters.country.items"
            [collapsed]="filters.country.collapsed"
            (toggled)="filterToggled.emit('country')"
            (changed)="filter({ country: $event.items, filterName: 'country' })">
          </filter-checkbox-list>


        </div>

    </div>

    <div class="body " *ngIf="pager.totalElements == 0">
      <company-search-result-tags
        (changed)="filter($event)"
        [filters]="filters">
      </company-search-result-tags>
        <div class="notfound">
            <i class="far fa-file-search mb-4"></i>
            Sorry, we couldn't find anything. Please revise your search criteria.
        </div>
    </div>
    <div class="card p-2">
    <div class="body pt-0" *ngIf="pager.totalElements > 0">
        <div class="result ">
            <span *ngIf="loading; else foundSummary">
                <div class="spinner">
                    <div class="spinner-bar"></div>
                </div>
            </span>
            <ng-template #foundSummary>
                <span>
                    {{ pager.totalElements | number }} companies <span *ngIf="searchTerm">for <strong>"{{ searchTerm }}"</strong></span>
                </span>
                <company-search-result-tags
                    (changed)="filter($event)"
                    [filters]="filters">
                </company-search-result-tags>
            </ng-template>
        </div>
        <div class="sort">
            <div class="sort-btn">
              <button style="margin-left: 2px" mat-raised-button color="primary" (click)="openDialog()">
                Save Search
              </button>
            </div>
            <pager [totalPages]="pager.totalPages"
                [totalElements]="pager.totalElements"
                [pageNumber]="pager.pageNumber"
                [pageSize]="pager.pageSize"
                (changed)="turnPage($event.pageNumber, $event.pageSize)">
            </pager>
        </div>

          <table class="table">
            <thead>
                <tr>
                    <!-- <th class="checked">
                        <label class="checkbox">
                            <input type="checkbox">
                            <span></span>
                        </label>
                    </th> -->
                    <th>
                        <button class="btn" (click)="sort('companyName')">
                            Company
                            <i [ngClass]="getSortClass('companyName')"></i>
                        </button>
                    </th>
                    <th class="industry">
                        <button class="btn" (click)="sort('industry')">
                            Industry
                            <i [ngClass]="getSortClass('industry')"></i>
                        </button>
                    </th>
                    <th class="sales">
                        <button class="btn" (click)="sort('revenueRange')">
                            Sales
                            <i [ngClass]="getSortClass('revenueRange')"></i>
                        </button>
                    </th>
                    <th>
                        <button class="btn" (click)="sort('phone')">
                            Phone
                            <i [ngClass]="getSortClass('phone')"></i>
                        </button>
                    </th>
                    <th class="location">
                        <button class="btn" (click)="sort('city')">
                            Location
                            <i [ngClass]="getSortClass('city')"></i>
                        </button>
                    </th>
                    <th class="website" nowrap="false">
                        <button class="btn" (click)="sort('website')">
                            URL
                            <i [ngClass]="getSortClass('website')"></i>
                        </button>
                    </th>
                   <!-- <th class="contacts">
                        <button class="btn" (click)="sort('activeContacts')">
                            Contacts
                            <i [ngClass]="getSortClass('activeContacts')"></i>
                        </button>
                    </th>
                    <th class="crm padding">Actions</th>-->
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of dataSource">
                    <!-- <td class="checked">
                      <mat-checkbox color="primary" (change)="selectCompany($event,item)"></mat-checkbox>
                    </td> -->
                    <td class="company">
                        <a href [routerLink]="['/company', item.id]">{{ item.companyName | titlecase }}</a>
                    </td>
                    <td class="industry">
                        <span>{{ item.industry | titlecase}}</span>
                    </td>
                    <td class="white-space sales">
                        <span>{{ item.revenueRange }}</span>
                    </td>
                    <td class="white-space phone">
                        <a href="tel:{{ item.phone }}">{{ item.phone }}</a>
                    </td>
                    <td class="location white-space">
                        <span>{{ item.city }}, {{ item.state }}</span>
                    </td>
                    <td class="website" ><a [href]="'//' + item.website" target="_blank" title="{{ item.website }}">{{ item.website }}</a></td>
                   <!-- <td class="contacts">{{ item.activeContacts }} <span class="text-silver">({{ item.totalContacts }})</span></td>
                    <td class="crm">
                        <button>
                            CRM
                            <i class="fas fa-arrow-alt-to-bottom"></i>
                        </button>
                    </td>-->
                </tr>
            </tbody>
        </table>
    </div>
  </div>
</div>
